import { render, staticRenderFns } from "./CodeBatchDetailView.vue?vue&type=template&id=7e87bf95&scoped=true"
import script from "./CodeBatchDetailView.vue?vue&type=script&lang=js"
export * from "./CodeBatchDetailView.vue?vue&type=script&lang=js"
import style0 from "./CodeBatchDetailView.vue?vue&type=style&index=0&id=7e87bf95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e87bf95",
  null
  
)

export default component.exports